let gridConfig = {
    icons: {
        sortAscending: '<i className=""></i>', //ag-icon ag-icon-asc
        sortDescending: '<i className=""></i>',     //ag-icon ag-icon-desc          
    },
    defaultColDef: {
        flex: 1,
        filter: false,
        autoHeight:true
    }
}

export default gridConfig;